import {useLocation} from 'react-router-dom';
import type {BreadcrumbItem} from '@/components/breadcrumbs/Breadcrumbs';
import useCreatorProfileQuery from '@/hooks/queries/use-creator-profile-query';
import useBrandId from '@/hooks/use-brand-id';
import {CREATOR_BREADCRUMB_ROUTES} from '../breadcrumbRouteDefinitions';
import {matchBreadcrumbRoutes} from '../breadcrumbRouteTypes';

function useCreatorBreadcrumbItems(): BreadcrumbItem[] | null {
  const {pathname} = useLocation();
  const brandId = useBrandId();

  const matched = matchBreadcrumbRoutes(CREATOR_BREADCRUMB_ROUTES, pathname);

  const {creatorId} = matched?.params ?? {};

  const {profile: creatorProfile} = useCreatorProfileQuery({
    profileId: creatorId ?? null,
    brandId,
    enabled: !!creatorId,
    include: [],
  });

  if (!matched) return null;

  const data = {
    creatorName: creatorProfile?.displayName,
  };

  return matched.route
    .getItems(matched.params, data)
    .filter((item) => item.label);
}

export default useCreatorBreadcrumbItems;
